import { render, staticRenderFns } from "./CellRendererPlotCategory.vue?vue&type=template&id=046d8cf4&scoped=true&"
import script from "./CellRendererPlotCategory.vue?vue&type=script&lang=js&"
export * from "./CellRendererPlotCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d8cf4",
  null
  
)

export default component.exports